const AXEPTIO_TRIGGER_SELECTOR = "[data-axeptio-banner-trigger]";

function attachAxeptioHandlers() {
    const triggers = document.querySelectorAll(AXEPTIO_TRIGGER_SELECTOR);

    if (!triggers.length) {
        return;
    }

    triggers.forEach((trigger) => {
        trigger.addEventListener("click", handleTriggerClick);
    });
}

function handleTriggerClick(event) {
    event.preventDefault();

    if (window.axeptioSDK && typeof window.axeptioSDK.openCookies === "function") {
        window.axeptioSDK.openCookies();
        return;
    }

    // Ensure the Axeptio callback queue exists so we can open the banner once it loads
    window._axcb = window._axcb || [];
    window._axcb.push((sdk) => {
        window.axeptioSDK = sdk;

        if (typeof sdk.openCookies === "function") {
            sdk.openCookies();
        }
    });
}

document.addEventListener("DOMContentLoaded", attachAxeptioHandlers);
